"use client";

import { createContext, useContext } from "react";

import { DEFAULT_SITE_CONFIG, type SiteConfig } from "./siteConfig";

/*
 * 실행 시점 설정의 클라이언트 쪽 — `SiteProvider` · `useSite()`.
 *
 * 🔴 **값을 여기서 받아 오지 않습니다.** 루트 `layout.tsx`(서버)가 매 요청 `GET /site` 를
 *    읽어 내려 준 값을 그대로 나눠 줄 뿐입니다 — 브라우저가 따로 부르면 첫 그림은
 *    기본값으로 그렸다가 바뀌어, 스킨·브랜드색이 한 번 스쳤다 바뀝니다(앱 래핑에서는
 *    매 진입마다 번쩍임). 그래서 첫 HTML 에 이미 들어 있어야 합니다.
 *
 * 🔑 Provider 밖(서버 렌더 검사·스토리 등)에서는 코드 기본값을 돌려줍니다.
 *
 * 사용: `const { skin, brand, settings, legal } = useSite();`
 */
const SiteContext = createContext<SiteConfig>(DEFAULT_SITE_CONFIG);

export function SiteProvider({ value, children }: { value: SiteConfig; children: React.ReactNode }) {
  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
}

export function useSite(): SiteConfig {
  return useContext(SiteContext);
}
